module.exports = __webpack_public_path__ + "static/media/midtrans-tnc-template-13-jan-2017.253c4a6e.pdf";